'use client';

import { useMemo } from 'react';
import { useReportWebVitals } from 'next/web-vitals';

export default function WebVitals() {
  // Mantener la misma referencia evita duplicados
  const handler = useMemo(
    () => (metric) => {
      try {
        // Si usás @next/third-parties/google ya tenés gtag()
        if (typeof window.gtag !== 'function') return;

        // GA4 acepta decimales, pero mantener "value" como entero evita warnings.
        const intValue =
          metric.name === 'CLS'
            ? Math.round(metric.value * 1000) // CLS suele ser < 1
            : Math.round(metric.value);

        window.gtag('event', metric.name, {
          // Parámetros “built-in”
          value: intValue,
          non_interaction: true,
          event_label: metric.id, // id único por carga

          // Parámetros custom útiles para BigQuery/Looker
          metric_id: metric.id,
          metric_value: metric.value,
          metric_delta: metric.delta,
          metric_rating: metric.rating,
          navigation_type: metric.navigationType,

          // Si activás attribution (ver paso 3), mandamos el elemento culpable
          ...(metric.attribution && {
            debug_target:
              metric.attribution.largestShiftTarget || // CLS
              metric.attribution.target ||              // LCP (web-vitals 6, Next 16.3+)
              metric.attribution.element ||             // LCP (web-vitals 4)
              metric.attribution.interactionTarget ||   // INP
              undefined,
          }),
        });
      } catch {}
    },
    []
  );

  useReportWebVitals(handler);
  return null;
}
